import { Box, Grid, GridItem } from "@chakra-ui/layout";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserJobListCard from "../Components/UserJobListCard";
import { getJobListAction } from "../Redux/Actions/jobAction";

const UserJobsPage = () => {
  const { loading, jobs } = useSelector((state) => state.JobList);
  console.log('jobs:', jobs)

  const dispatch = useDispatch();

  function getData() {
    dispatch(getJobListAction());
  }

  useEffect(() => {
    getData();
  }, []);


  const hanldeClick =(id)=>{

  }
  return (
    <Box w={"80%"} m="auto" mt="6">
      <Grid templateColumns="repeat(3, 1fr)" gap={6}>
        {!loading &&
          jobs &&
          jobs.jobsList?.map((ele, i) => {
            return (
              <GridItem w="100%" h="100%" key={ele._id}>
                <UserJobListCard {...ele}></UserJobListCard>
              </GridItem>
            );
          })}
      </Grid>
    </Box>
  );
};

export default UserJobsPage;
